import React from 'react';
import { Col, Button, Menu, Dropdown, Modal } from 'antd';
import { Link } from 'react-router-dom';
import { UsergroupAddOutlined } from '@ant-design/icons';

import SpanComponent from '@sharedComponent/span-component';
import ImageComponent from '@sharedComponent/image-component';
import { showAddAffiliate } from '@constants';
import { isAuth } from '@helpers';
import { images } from '@assets/img';

const HeaderPresentational = ({
	handleLogoutModel,
	handleLogout,
	confirmLogoutVisible,
	handleRouting,
	showAccessLevel = false,
	title,
	userDetails,
	hideAddAffiliate = false,
}) => {
	const { accessLevel, profileImage, userName } = userDetails || {
		accessLevel: null,
		profileImage: null,
		userName: null,
	};

	const menu = (
		<Menu>
			<Menu.Item onClick={() => handleRouting('/profile')}>Profile</Menu.Item>
			<Menu.Item onClick={handleLogout}>Logout</Menu.Item>
		</Menu>
	);

	return (
		<Col className="k_header">
			<Col className="pageName">{title}</Col>
			<Col style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
				{showAccessLevel && (
					<Col style={{ paddingRight: '20px' }} className="access_level">
						<SpanComponent>Access Level : </SpanComponent>
						<SpanComponent className="admin_name"> {accessLevel} </SpanComponent>{' '}
					</Col>
				)}
				{isAuth(showAddAffiliate, accessLevel) && !hideAddAffiliate && (
					<Col style={{ paddingRight: '20px' }} className="access_level">
						<Link to="/add-affiliate">
							<Button type="primary" style={{ height: '36px', borderRadius: 27 }} icon={<UsergroupAddOutlined />} size={'middle'}>
								Invite Affiliate
							</Button>
						</Link>
					</Col>
				)}

				<Dropdown overlay={menu}>
					<Col className="username_area" style={{ paddingLeft: '' }}>
						<ImageComponent src={profileImage} />
						<Col className="username">{userName}</Col>
					</Col>
				</Dropdown>
			</Col>

			<Modal visible={confirmLogoutVisible} title={null} centered={true} footer={null} closable={false} className="delete_modal_area">
				<Col className="delete_modal_body">
					<Col style={{ textAlign: 'center', marginBottom: '20px', marginTop: '20px' }}>
						<ImageComponent style={{ maxWidth: '250px' }} src={images.signout} />
					</Col>
					<Col className="delete_modal_body_content">Are you sure that you want to sign out?</Col>
				</Col>
				<Col className="delete_modal_footer">
					<Button className="cancel_btn" onClick={() => handleLogoutModel(false)}>
						No
					</Button>
					<Button className="delete_btn" onClick={() => handleLogoutModel(false, 'logout')}>
						Yes
					</Button>
				</Col>
			</Modal>
		</Col>
	);
};

export default HeaderPresentational;
